import useDictionary from '../../dictionaries/context/useDictionary';
import { getRepeatableSpace } from '../getRepeatableSpace/getRepeatableSpace';
import { GroupName } from '../types/GroupName';
import { SpaceName } from '../types/SpaceName';
import { addTextToSpace } from './addTextToSpace';
import { fillUtilityProps } from './fillUtilityProps';
import { useSpaceContext, UseSpaceContext } from './useSpaceContext';

/**
 * Hook for auto connection of space to implementation to default contexts
 * @param groupName
 * @param spaceName
 * @param context
 * @returns
 */
export const useRepeatableSpace = (
  groupName: GroupName,
  spaceName: SpaceName,
  context: UseSpaceContext,
) => {
  const spaceContext = useSpaceContext(context);
  const { gT } = useDictionary();

  const repSpace = getRepeatableSpace(groupName, spaceName, spaceContext);

  const rows = repSpace.rows.map((row) => {
    const get = (space: string) => {
      const og = row.get(space);
      if (!og) return undefined;
      const filled = fillUtilityProps(og);
      return addTextToSpace(filled, spaceContext, gT);
    };
    return {
      ...row,
      get,
      getMany: (spaceKeys: string[]) => {
        return spaceKeys.map(get);
      },
    };
  });

  return {
    ...repSpace,
    rows,
  };
};
